import React from "react"
import { Box } from "@mui/material"

import { AppDialogCancel, AppFormDrawer, AppFormGrid, AppFormSection } from "@components"
import { isEditUserSettingsAcrissDrawer, isOpenUserSettingsAcrissDrawer, userSettingAcrissFormData } from "../../../@signals"
import UserSettingAcrissDrawerColor from "./Color"
import UserSettingAcrissDrawerAcriss from "./Acriss"
import UserSettingAcrissDrawerSubmit from "./Submit"


export default function UserSettingAcrissDrawer() {
	const onClose = () => userSettingAcrissFormData.value = { }

	return <AppFormDrawer
		icon="palette"
		title={isEditUserSettingsAcrissDrawer.value ? 'Edit ACRISS' : 'New ACRISS'}
		subtitle="An ACRISS code and its colour"
		isOpen={isOpenUserSettingsAcrissDrawer.value}
		controller={onClose}
		footer={<>
			<AppDialogCancel onClick={onClose}/>
			<UserSettingAcrissDrawerSubmit/>
		</>}
	>
		<AppFormSection icon="palette" title="ACRISS">
			<AppFormGrid>
				<Box sx={{ gridColumn: 'span 12' }}><UserSettingAcrissDrawerAcriss/></Box>
				<Box sx={{ gridColumn: 'span 12' }}><UserSettingAcrissDrawerColor/></Box>
			</AppFormGrid>
		</AppFormSection>
	</AppFormDrawer>
}
